import { createFileRoute } from "@tanstack/react-router";

import FinishGameSessionPage from "~/pages/gameSession/FinishGameSessionPage.tsx";

export const Route = createFileRoute("/_auth/game-session/$gameSessionId/finish")({
    component: FinishGameSessionPage,
});
